// extracted by mini-css-extract-plugin
export default {"container":"AuthorInfo_container__ExlLG","nameDate":"AuthorInfo_nameDate__lx9KJ"};